import { Injectable } from '@angular/core';

export enum StorageKeys {
  TOKEN_RESPONSE = 'token_resp',
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  TOKEN_TYPE = 'token_type',
  ACCESS_TOKEN_STORED_AT = 'access_token_stored_at',
  EXPIRES_AT = 'expires_at',
  GRANTED_SCOPES = 'granted_scopes',
  TOKEN_EXCHANGE_ENTERPRISE_ID = 'token_exchange_enterprise_id',
  ID_TOKEN = 'id_token',
  PERMISSIONS = 'permissions',
  USERNAME = 'username',
  USER_ID = 'user_id',
  CURRENT_ENTERPRISE_ID = 'current_enterprise_id',
  CURRENT_FACILITY_ID = 'current_facility_id',
  THREE_MOTION_TOKEN_RESPONSE = '3m_token_resp',
  EXCHANGE_RATE = 'exchange_rate_json',
  CURRENT_USER_ROLE = 'current_user_role',
  SIDEBAR_STATE = 'sidebar_state',
  LOGOUT_ERROR = 'logout_error',
}

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  getItem(item: StorageKeys): string | null {
    return localStorage.getItem(item);
  }

  setItem(item: StorageKeys, value: string): void {
    localStorage.setItem(item, value);
  }

  removeItem(item: StorageKeys): void {
    localStorage.removeItem(item);
  }

  clear(): void {
    localStorage.clear();
  }
}
